import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";

import { getImageBase64, validFile } from "../../../../../utils";
import { FlexColumnCenter } from "../../../../Common/Styles";
import { UploadProps } from "./Upload";

const Upload = ({
  fileInputRef,
  setImageUrl,
  setIsCropModalOpen,
}: UploadProps.IProps) => {
  const { typography } = useTheme();

  return (
    <Container>
      <UploadContainer
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          const files = e.dataTransfer.files;
          if (!files.length) return;
          const validFiles = validFile(files);
          if (!validFiles.length) return;
          getImageBase64(validFiles[0]).then((url) => {
            setImageUrl(url);
            setIsCropModalOpen(true);
          });
        }}
      >
        <Components.IconButton
          iconType={"Image"}
          disabled={false}
          size="Small"
          kind="Secondary"
          onClick={() => {}}
        />

        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text={"Recommended cover image resolution is 1920x1080 pixels"}
          lineHeight="line-height-400"
        />

        <Components.Text
          style={{ tokenStyle: typography.Body.S }}
          text={"Or drag and drop here"}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </UploadContainer>
    </Container>
  );
};

export default Upload;

const UploadContainer = styled(FlexColumnCenter)`
  width: 100%;
  cursor: pointer;
  position: relative;
  height: 125px;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  border: 1px dashed
    ${({ theme }) => theme.Color.border["ui-border-emphasize-brand"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
`;

const Container = styled.div`
  max-width: 906px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
